import PropTypes from "prop-types"

export const OptionPropTypes = {
  color: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
}

export const BagPropTypes = {
  src: PropTypes.string.isRequired,
  modelName: PropTypes.string,
  logo: PropTypes.object.isRequired,
  placeholder: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.shape(OptionPropTypes)),
}
